import React from "react";
import {BrowserRouter as Router,Route} from "react-router-dom";
import './classicui.css';
import './App.css';
import './App.css';
import Navbar from "./Navbar";
import Footer from "./Footer";
import Home from "./Home"
import Coffee from "./Coffee";
import Contact from "./Contact";
import About from "./About";
import Thankyou from "./Thankyou";

 
function App() { 

   return (
      <Router>
      <div>
      <Route exact path="/thankyou" component = {Thankyou} />
     <Navbar />
     <Route exact path="/" component = {Home} />
     <Route exact path="/coffee-shop" component = {Coffee} />
     <Route exact path="/about" component = {About} />
     <Route exact path="/contact" component = {Contact} />
    
      <Footer />
      </div> 
      </Router>
    );
   }

export default App;








